import { comicCategories } from '@/mocks/comics';

const colorMap: Record<string, { bubble: string; text: string }> = {
  primary: { bubble: 'bg-primary-100 text-primary-700', text: 'text-primary-700' },
  accent: { bubble: 'bg-accent-100 text-accent-700', text: 'text-accent-700' },
  secondary: { bubble: 'bg-secondary-100 text-secondary-800', text: 'text-secondary-800' },
};

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
            <i className="ri-grid-fill" />
            漫画分类
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">海量国漫，分类随心逛</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            从热血冒险到恋爱甜宠，从玄幻修仙到悬疑推理，手机版与 APP 端全部分类同步更新。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-4">
          {comicCategories.map((cat) => {
            const c = colorMap[cat.color] ?? colorMap.primary;
            return (
              <a
                key={cat.name}
                href="#featured"
                className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
              >
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl ${c.bubble}`}>
                  <i className={cat.icon} />
                </span>
                <span className="flex min-w-0 flex-col">
                  <span className={`text-sm font-bold md:text-base ${c.text}`}>{cat.name}</span>
                  <span className="mt-0.5 text-xs text-foreground-500">{cat.count} 部</span>
                </span>
                <i className="ri-arrow-right-s-line ml-auto text-lg text-foreground-300 transition-transform group-hover:translate-x-1" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}